var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menuButton",on:{"click":_vm.select}},[_c('img',{attrs:{"src":_vm.selected ?_vm.icons[1]:_vm.icons[0],"alt":""}}),_c('div',{class:_vm.selected?'show':'title'},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }